import { useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth }  from '@/context/AuthContext'
import { useTheme } from '@/context/ThemeContext'
import AuroraSidebar    from '@/components/layouts/AuroraSidebar'
import LanguageSwitcher from '@/components/ui/LanguageSwitcher'
import { Pill, UserPill } from '@/components/aurora'
import { Menu, Moon, Sun } from 'lucide-react'

export default function DashboardLayout({ children }) {
  const { t }                   = useTranslation()
  const { user }                = useAuth()
  const { isDark, toggleTheme } = useTheme()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="flex h-full" style={{ background: 'var(--bg)' }}>
      <AuroraSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col min-w-0 h-full">
        {/* Top bar */}
        <header
          className="flex items-center justify-between gap-3 px-4 lg:px-6 py-3.5"
          style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}
        >
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden grid place-items-center w-9 h-9 rounded-xl transition-colors"
            style={{ background: 'var(--bg-soft)', border: '1px solid var(--border)', color: 'var(--ink-2)' }}
            aria-label="Menu"
          >
            <Menu size={18} strokeWidth={2} />
          </button>

          <div className="flex-1" />

          <div className="flex items-center gap-1.5">
            <LanguageSwitcher />
            <Pill
              iconOnly
              onClick={toggleTheme}
              title={isDark ? t('theme.light', "Yorug' rejim") : t('theme.dark', "Qorong'u rejim")}
              aria-label="Toggle theme"
            >
              {isDark ? <Sun size={14} strokeWidth={2} /> : <Moon size={14} strokeWidth={2} />}
            </Pill>
            <UserPill as={Link} to="/settings" user={user} />
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          {children ?? <Outlet />}
        </main>
      </div>
    </div>
  )
}
